import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/service/auth.service';
import { RestClientService } from 'src/app/core/service/rest-client.service';
import { UtilitiesService } from 'src/app/core/service/utilities.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-bulletin-prelevement',
  templateUrl: './bulletin-prelevement.component.html',
  styleUrls: ['./bulletin-prelevement.component.scss']
})
export class BulletinPrelevementComponent implements OnInit {

  @Input() currentPrelevement : any = {};
  @Input() currentAccueil : any;
  @Input() isRadiologie;
  @Input() currentReception;

  @Output() close: EventEmitter<number> = new EventEmitter();

  listeDocuments : any = [];
  busySave : Subscription;
  itemToSave : any = {};
  user : any = {};

  constructor(
        private authService: AuthService,
        private restClient: RestClientService,
        private utilities: UtilitiesService
  ) { 
      this.user = this.authService.currentUserValue;
  }


  confirmSaveItem() {

    if(!this.listeDocuments || this.listeDocuments.length == 0) {
        this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez ajouter les images du belletin !",
        "bottom",
        "center"
      );
      return;
    }

    let listBulletinToSave = [];

     Swal.fire({
          title: "Bulletin",
          text: "Voulez-vous poursuivre cette action ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0665aa",
          cancelButtonColor: "#aaa4a4",
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        }).then((result) => {
          if (result.value) {

            this.listeDocuments.forEach(element => {
              listBulletinToSave.push({
                fileBase64 : element.fileBase64,
                extension : element.extension,
                fileName : element.fileName
              });
            });

            this.itemToSave.datasBulletin = listBulletinToSave;
            this.itemToSave.id = this.currentPrelevement?.id || this.currentReception?.id;

            this.SaveItem(this.itemToSave);
          }
        });

  }

  SaveItem(item) {

    var request = {
      user: this.user.id,
      datas: [item],
    };
    
    this.busySave = this.restClient
      .post(("exCompPrelevement/update"), request)
      .subscribe(
        (res) => {
          if (!res["hasError"]) {
            if (res["items"] && res["items"].length > 0) {
              this.utilities.showNotification(
                "snackbar-success",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
              this.close.emit();
            }
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
        }
      );
  }

  handleClose() {
    this.close.emit();
  }

  getCurrentDocument($event) {
    console.log(" $event ",$event);
    this.listeDocuments = [...$event];
  }

  ngOnInit(): void {

    if(this.currentPrelevement?.datasBulletin && this.currentPrelevement?.datasBulletin.length) {
      this.currentPrelevement?.datasBulletin.forEach(element => {
        element.libelle = element.libelle || element.link;
      });
    }
   
  }

}
